import { render, staticRenderFns } from "./SaveRole.vue?vue&type=template&id=a4cb6c28&scoped=true"
import script from "./SaveRole.vue?vue&type=script&lang=js"
export * from "./SaveRole.vue?vue&type=script&lang=js"
import style0 from "./SaveRole.vue?vue&type=style&index=0&id=a4cb6c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cb6c28",
  null
  
)

export default component.exports